import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Tooltip from '../../../components/Tooltip';
import Typography from '../../../components/Typography';
import { i18nNS } from '../../../i18n';
import AcadlyLogo from '../../../icons/AcadlyLogoSquare';
import LogOutIcon from '../../../icons/LogOutIcon';
import { LogoutButton } from './styles';
import useHeader from './vm';

const Header = () => {
  const { t } = useTranslation([i18nNS.HOME, i18nNS.GLOSSARY]);
  const { handleLogout } = useHeader();

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <AcadlyLogo size={48} />
      <Typography variant="h4Bold" color="common.black">
        {t('acadly_in_class_activities', { ns: i18nNS.HOME })}
      </Typography>
      <Tooltip title={t('logout', { ns: i18nNS.GLOSSARY })}>
        <LogoutButton size="small" variant="text" color="error" onClick={handleLogout} iconOnly>
          <LogOutIcon size={24} />
        </LogoutButton>
      </Tooltip>
    </Stack>
  );
};

export default Header;
